<template>
    <div
        class="table-with-tabs"
        :class="{'preloader-content': isPreloader}"
    >
        <div
            v-if="isPreloader"
            class="preloader fa fa-circle-o-notch fa-spin">
        </div>
        <table-tabs
            :tableTabs="tableTabs"
            :tableTabKeyActive="tableTabActive"
            @onClickTab="onClickTab"
        />
        <table-base-v2
            :columns="tableDataActive.columns || new Map()"
            :rows="tableDataActive.rows || []"
        />
    </div>
</template>

<script>
import TableTabs from './TableTabs';
import TableBaseV2 from './TableBaseV2';
export default {
    name: 'TableWithTabs',
    components: {
        TableTabs,
        TableBaseV2
    },
    /**
     * входные данные компонента
     * @property {object} tableTabs - таблицы разбитые по табам
     * @property {boolean} isPreloader - условие показа прелоадера
     */
    props: {
        tableTabs: {
            type: Object,
            default: () => ({})
        },
        isPreloader: {
            type: Boolean,
            default: false
        }
    },
    /**
     * данные компонента
     * @property {string} tableTabActive - активный таб
     */
    data: () => ({
        tableTabActive: ''
    }),
    computed: {
        /**
         * активная таблица
         * @returns {object}
         */
        tableDataActive() {
            let tableDataActive = this.tableTabActive !== '' ? this.tableTabs[this.tableTabActive].tableData : {};
            return tableDataActive;
        }
    },
    watch: {
        /**
         * при изменении входных данных выставляем активный таб
         */
        tableTabs: function() {
            this.tableTabActive = Object.keys(this.tableTabs)[0]
        }
    },
    methods: {
        /**
         * событие клика по табу
         * @param {string} tabKey - ключ таба
         */
        onClickTab(tabKey) {
            this.tableTabActive = tabKey;
        }
    }
}
</script>

<style lang="scss" scoped>
    .table-with-tabs {
        position: relative;
        // overflow-x: auto;
    }
    .table-with-tabs__tabs {
        display: flex;
        margin-bottom: 20px;
    }
    .table-with-tabs__tab-item {
        margin-right: 5px;
        border: none;
        background: none;
        cursor: pointer;
        outline: none;
        color: #696969;
    }
    .table-with-tabs__tab-item__active {
        color: #258df5;
    }
</style>